import React, { useState } from "react";
import {
  Box,
  Button,
  Drawer,
  FormControl,
  Grid,
  MenuItem,
  TextField,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import Loader from "../component/loading-screen/Loader";
import ModalHeader from "./ModalHeader";
import ModalFooter from "./ModalFooter";
import { get, postJsonData } from "../network/ApiController";
import ApiEndpoints from "../network/ApiEndPoints";
import { apiErrorToast, okSuccessToast } from "../utils/ToastUtil";

const AddVpa = ({ refresh }) => {
  const [open, setOpen] = useState(false);
  const [request, setRequest] = useState(false);
  const [users, setUsers] = useState([]);
  const [userId, setUserId] = useState("");

  const [formData, setFormData] = useState({
    prefix: "",
    suffix: "",
  });
  // Open and Close Drawer
  const handleOpen = () => {
    setOpen(true);
    getUsers();
  };
  const handleClose = () => {
    setFormData({
      prefix: "",
      suffix: "",
    });
    setUserId("");
    if (refresh) refresh();
    setOpen(false);
  };
  const getUsers = () => {
    get(
      ApiEndpoints.GET_USERS,
      `page=1&paginate=10&role=Api&export=`,
      setRequest,
      (res) => {
        const usersArray = res?.data?.data || [];
        setUsers(
          usersArray.map((item) => ({
            id: item.id,
            name: item.name,
          })),
        );
      },
      (error) => apiErrorToast(error),
    );
  };

  // Handle Input Changes
  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  // Handle Submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    setRequest(true);
    const data = {
      user_id: userId,
      vpa: `${formData.prefix}@${formData.suffix.replace(/^@/, "")}`,
    };
    postJsonData(
      ApiEndpoints.ADD_VPA,
      data,
      setRequest,
      (res) => {
        handleClose();
        okSuccessToast(res?.data?.message || res?.message);
        if (refresh) refresh();
      },
      (err) => {
        apiErrorToast(err);
      },
    );
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "end",
      }}
    >
      <Button
        variant="outlined"
        onClick={handleOpen}
        startIcon={<AddCircleOutlineIcon />}
        sx={{
          display: "flex",
          alignItems: "center",
          padding: "8px",
          fontSize: "12px",
          color: "#ffffff",
          fontWeight: "700",
          borderRadius: "8px",
          transition: "all 0.3s ease",
          justifyContent: "center",
          background: "#00693E",
          "&:hover": {
            backgroundColor: "#122480",
          },
        }}
        aria-label="Add Vpa"
      >
        ADD
      </Button>
      <Drawer open={open} onClose={handleClose} anchor="right">
        <Box sx={{ width: 400, p: 2 }}>
          <Loader loading={request} />
          <ModalHeader title="Add Vpa" handleClose={handleClose} />
          <Box
            component="form"
            id="AddVpaForm"
            autoComplete="off"
            onSubmit={handleSubmit}
            sx={{
              "& .MuiTextField-root": { m: 1 },
            }}
          >
            <Grid container>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <TextField
                    label="User"
                    select
                    size="small"
                    required
                    value={userId}
                    onChange={(e) => setUserId(e.target.value)}
                  >
                    {users.map((user) => (
                      <MenuItem key={user.id} value={user.id}>
                        {user.name} ({user.id})
                      </MenuItem>
                    ))}
                  </TextField>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  id="prefix"
                  label="VPA Prefix"
                  size="small"
                  required
                  value={formData.prefix}
                  onChange={handleInputChange}
                  helperText="Example: john123"
                />
              </Grid>

              <Grid item xs={12} sx={{ mt: 2 }}>
                <TextField
                  fullWidth
                  id="suffix"
                  label="VPA Suffix"
                  size="small"
                  required
                  value={formData.suffix}
                  onChange={handleInputChange}
                  placeholder="ybl"
                  helperText="Only enter the provider name (e.g. ybl, okhdfcbank, axisbank). Do not include @."
                />
              </Grid>
            </Grid>
            <Box sx={{ mt: 2 }}>
              <ModalFooter form="AddVpaForm" request={request} />
            </Box>
          </Box>
        </Box>
      </Drawer>
    </Box>
  );
};

export default AddVpa;
